import React from "react";
import { MapPin } from "lucide-react";

const LOGO_URL = process.env.REACT_APP_LOGO_URL;

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-[#1A2F2A]/60 py-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {/* Logo + Address */}
          <div>
            <img
              src={LOGO_URL}
              alt="Cybersyn"
              className="h-7 w-auto mb-4 opacity-60"
            />
            <div className="flex items-start gap-2 text-[#94A3B8] text-sm">
              <MapPin size={14} className="mt-0.5 flex-shrink-0 text-[#34D399]/50" />
              <address
                data-testid="footer-address"
                className="not-italic leading-relaxed"
              >
                Cybersyn Dynamics LLC
                <br />
                16192 Coastal Highway,
                <br />
                Lewes, DE 19958 USA
              </address>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-col items-start md:items-end gap-3">
            <div className="flex gap-6">
              <a
                href="https://scholar.google.com/citations?hl=en&user=DZxHODAAAAAJ"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-scholar"
                className="text-[#94A3B8] hover:text-[#34D399] text-sm font-mono transition-colors"
              >
                Scholar
              </a>
              <a
                href="https://www.linkedin.com/in/mancillamontero/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="text-[#94A3B8] hover:text-[#34D399] text-sm font-mono transition-colors"
              >
                LinkedIn
              </a>
              <a
                href="mailto:javier@cybersyn.systems"
                data-testid="footer-email"
                className="text-[#94A3B8] hover:text-[#34D399] text-sm font-mono transition-colors"
              >
                Email
              </a>
            </div>
            <p className="text-[#94A3B8]/40 text-xs font-mono">
              &copy; {new Date().getFullYear()} Cybersyn Dynamics LLC. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
